import fetch from "@lib/fetch";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { simulationCasesPath } from "./constants";
import type { SimulationCase, SimulationCasesResult, SimulationCasesTableParams } from "./types";
import { isSimulationCasesResult } from "./validators";

export const getSimulationCases = reactQueryTableFetcherAdapter<
  typeof simulationCasesPath,
  SimulationCasesTableParams,
  SimulationCase,
  SimulationCasesResult
>(
  simulationCasesPath,
  (
    signal: AbortSignal,
    { appGroupId, limit = 20, start = 0 }: SimulationCasesTableParams
  ): Promise<SimulationCasesResult> =>
    fetch(`/${appGroupId}/conversational/simulation/cases`, "GET", { limit, start }, { signal }),
  isSimulationCasesResult
);
